import numeral from 'numeral';
import 'numeral/locales/es-es';

numeral.locale('es-es');

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
export const formatFileSize = (bytes, decimals) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals || 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

// Numbers format
const customFormat = val => (val.toString().indexOf('.') > -1 ? '0,0.00' : '0,0');
export const number = val => numeral(val).format(customFormat(val));
export const currency = val => numeral(val).format(`${customFormat(val)} $`);
export const taxPercent = val => numeral(val).format('0 %');

// Convert from KB to MB
export const kBToMB = (kb, decimals = 0) => {
  const k = 1024;
  if (decimals === null) return kb / k;
  return (kb / k).toFixed(decimals);
};

// Convert from MB to KB
export const MBToKB = (mb, decimals = 0) => {
  const k = 1024;
  if (decimals === null) return mb * k;
  return (mb * k).toFixed(decimals);
};
